/**
 * Shared JSON upload/download helpers for agent definitions (used by File menu and persistence).
 */

export function normalizeFunctionsFromLegacyParameters(funcs) {
  return (funcs || []).map((fn) => {
    if (fn.input_schema) return fn;
    if (!fn.parameters) return fn;

    const properties = fn.parameters.reduce((acc, { name, type, source, from, description, in: location }) => {
      if (!name) return acc;
      acc[name] = {
        type,
        source,
        from,
        description,
        in: location,
      };
      return acc;
    }, {});

    const { parameters, ...rest } = fn;
    return {
      ...rest,
      input_schema: {
        type: 'object',
        properties,
      },
    };
  });
}

export function normalizeUploadedAgentData(data) {
  if (Array.isArray(data.functions)) {
    data.functions = normalizeFunctionsFromLegacyParameters(data.functions);
  }
  return data;
}

/** Trigger file picker and parse JSON into agent shape; calls setData with normalized object. */
export function uploadAgentJsonFile(setData, setError) {
  const input = document.createElement('input');
  input.type = 'file';
  input.accept = '.json';
  input.onchange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (ev) => {
      try {
        const data = JSON.parse(ev.target.result);
        normalizeUploadedAgentData(data);
        setData(data);
      } catch (err) {
        setError(`Invalid JSON: ${err.message}`);
      }
    };
    reader.readAsText(file);
  };
  input.click();
}

export function downloadAgentJson(getData) {
  const data = getData();
  const name = (data?.name || 'agent').replace(/\s+/g, '-').replace(/[^a-zA-Z0-9-]/g, '') || 'agent';
  const jsonData = JSON.stringify(data, null, 2);
  const blob = new Blob([jsonData], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${name}.json`;
  link.click();
  URL.revokeObjectURL(url);
}
